import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { Models } from "api/types";
import { RepeatCashEntry } from "molecules/repeat-cash-entry/RepeatCashEntry";

// Maps to backend RepeatCashActivityType enum
const RepeatCashActivityType = {
  AddedByStaff: 0,
  GiftedByStaff: 1,
  AddedByMembership: 2,
  BankedReward: 3,
  Purchase: 4,
  Refund: 5,
  DeductedByStaff: 6,
  Unknown: 7,
  GiftCard: 8,
  ReferralReward: 9,
  ReferralRewardBonus: 10,
} as const;

export interface RepeatCashTransactionListProps {
  transactions: Models<"DisplayRepeatCashTransactionForPerson">[];
}

export const RepeatCashTransactionList = ({ transactions }: RepeatCashTransactionListProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!transactions.length) return null;

  const navigateToSource = (transaction: Models<"DisplayRepeatCashTransactionForPerson">) => {
    if (transaction.rewardId) {
      navigate(`/rewards/${transaction.rewardId}`);
      return;
    }

    if (transaction.orderId) {
      navigate(`/account/orders/${transaction.orderId}`);
      return;
    }

    if (transaction.reason) {
      navigate(`/account/wallet/repeatcash/${transaction.id}`);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="px-8 text-sub2 uppercase text-secondary">
        {t("repeatCashTransactionList.recentActivity")}
      </div>
      <div className="flex flex-col overflow-clip">
        {transactions?.map((i) => {
          const onClickHandler =
            i.rewardId || i.orderId || i.reason ? () => navigateToSource(i) : undefined;

          const title = i.activityTitle || i.activityDescription || "RepeatCash";
          const repeatCashType =
            i.activityType === RepeatCashActivityType.GiftCard ? "Gift" : undefined;

          return (
            <RepeatCashEntry
              key={i.id}
              title={title}
              date={i.created}
              amount={i.amountInCents}
              transactionType={i.transactionType}
              onClick={onClickHandler}
              repeatCashType={repeatCashType}
            />
          );
        })}
      </div>
    </div>
  );
};
